<script>
  import {M} from "../external";

  export let data,
    title = M.LIST_NAME,
    description = M.DESCRIBE_LIST;

  export function get() {
    return data;
  }

  $: if (!data.name) data.name = "";
</script>

<div class="popup-widget-wrapper">
  <div class="f-left col20">
    <div class="popup-input-wrapper">
      <h5 class="f-15">{title}</h5>
      <span class="light-gray-text">{description}</span>
      <input type="text" bind:value={data.name} />
    </div>
  </div>
</div>
